import React, { Component } from "react";
import { Grid, GridItem } from "../../../shared/components/presentation/grid/Grid";
import InputList from "../../../shared/components/presentation/input-list/InputList";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as webAppointmentActions from "../../actions/webAppointmentActions";
import { nextPage } from "../../functions/nextPage";
import * as defaultState from "../../constants/DefaultState";

export class AppointmentProviderPage extends Component {
  isValid() {
    let valid = this.props.appointment.type;
    return !!valid;
  }

  componentDidMount() {
    if (!this.props.appointment.type) {
      this.props.webAppointmentSetAppointmentType("In-office");
    }
  }

  render() {
    const title = "Is there a provider or visit type " + (this.props.forMe ? "you" : "they") + " would prefer?";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        inputs: [
          {
            type: "text",
            id: "preferredProvider",
            label: "Is there a preferred provider " + (this.props.forMe ? "you" : "they") + "’d like to see? If so, enter their name below. (Optional)",
            helperText: "This helps us identify the right provider for the appointment.",
            onChange: (ev) => {
              this.props.webAppointmentSetAppointmentProvider(ev.target.value);
            },
            existingContent: this.props.appointment.provider || undefined,
            maxLength: "140"
          },
          {
            type: "radio-list",
            id: "appointment-type",
            groupName: "appointment-type",
            legend: "What kind of visit is preferred?",
            helperText: "Not all providers offer virtual visits.",
            required: true,
            onChange: (ev) => {
              this.props.webAppointmentSetAppointmentType(ev.target.value);
            },
            radioWrapperClassName: "radio-button-inline radio-button-bold",
            radioProps: [
              {
                id: "in-office-visit",
                label: "In-office",
                value: "In-office",
                checked: this.props.appointment.type === "In-office"
              },
              {
                id: "virtual-visit",
                label: "Virtual (if available)",
                value: "Virtual",
                checked: this.props.appointment.type === "Virtual"
              },
              {
                id: "doesnt-matter-visit",
                label: "Doesn’t matter",
                value: "Doesn’t matter - either in-office or virtual (if available)",
                checked: this.props.appointment.type === "Doesn’t matter - either in-office or virtual (if available)"
              }
            ]
          }
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          [
            {
              type: "button",
              id: "back",
              className: "btn--secondary",
              value: "Back",
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: "button",
              id: "next",
              className: "btn--primary",
              value: "Next",
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage());
              }
            }
          ]
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className="web-appt__header">
              <h1>{title}</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

AppointmentProviderPage.propTypes = {
  webAppointmentSetAppointmentProvider: PropTypes.func.isRequired,
  webAppointmentSetAppointmentType: PropTypes.func.isRequired,
  appointment: defaultState.appointmentProptype,
  forMe: PropTypes.bool.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    appointment: state.webAppointmentForm.appointment,
    forMe: state.webAppointmentForm.forMe
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetAppointmentProvider: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentProvider(value)),
    webAppointmentSetAppointmentType: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentType(value))
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(AppointmentProviderPage);
